"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContributionRegistry = void 0;
const rxjs_1 = require("rxjs");
const Log_1 = __importDefault(require("../Log"));
const agent_1 = require("../agent");
const StreamContribution_1 = require("./StreamContribution");
class ContributionRegistry {
    constructor(platform) {
        this.SupportedContributionTypeMap = new Map([
            [
                'WEBRTC_UNREAL_STREAM',
                (id, owner, version, description) => {
                    return new StreamContribution_1.StreamContribution(id, this.platform.agent, owner, version, description);
                }
            ]
        ]);
        this.platform = platform;
    }
    listen(key) {
        const contributions = new Map();
        return new rxjs_1.Observable((subscriber) => {
            // Notify existing
            this.platform.agent.getContributions(key).then((existingContributions) => {
                existingContributions.forEach((c) => {
                    const { launchRequestId, modelId } = JSON.parse(c.data);
                    const contribution = this.SupportedContributionTypeMap.get(key)(c.id, new agent_1.RemoteAgent(c.agentId), 'cirrus-4.25', { launchRequestId, modelId });
                    contributions.set(c.id, contribution);
                    subscriber.next({ id: c.id, type: agent_1.ContributionTypes.CONTRIBUTION, contribution });
                });
            });
            // Listen for updates
            this.platform.agent.subscribeToContributions(key, (event) => {
                Log_1.default.info('received contribution: ' + JSON.stringify(event));
                if (event.contribution === agent_1.ContributionTypes.CONTRIBUTION) {
                    // TODO: streaming-agent reactor
                    // const streamData: {
                    //   id: string;
                    //   owner: IRemoteAgent;
                    //   version: string;
                    //   description: { modelName: string; modelId?: string; launchRequestId?: string };
                    // } = JSON.parse(event.data);
                    const { launchRequestId, modelId } = JSON.parse(event.data);
                    const contribution = this.SupportedContributionTypeMap.get(key)(event.id, new agent_1.RemoteAgent(event.agentId), 'cirrus-4.25', { launchRequestId, modelId });
                    contributions.set(event.id, contribution);
                    subscriber.next({ id: event.id, type: agent_1.ContributionTypes.CONTRIBUTION, contribution });
                }
                else if (event.contribution === agent_1.ContributionTypes.WITHDRAWAL) {
                    Log_1.default.info('contribution withdrawn: ' + JSON.stringify(event));
                    const contribution = contributions.get(event.id);
                    subscriber.next({ id: event.id, type: agent_1.ContributionTypes.WITHDRAWAL, contribution });
                }
            });
        });
    }
}
exports.ContributionRegistry = ContributionRegistry;
//# sourceMappingURL=ContributionRegistry.js.map